import React, { Component } from 'react';

import { Button, Badge } from 'react-bootstrap';

import * as constants from '../../config/constants/AppConstants';

import * as util from '../../library/utilitys';

const UI_SIZE = constants.AppSettings.UI_SIZE;

class CommonButtonBadge extends Component {

    constructor(props){
        super(props);
    }

        render = () => {
            let { inlineClass = '', callback, disabled = false, rounded = true } = this.props;

            let { text, count } = this.props.info;
    
            let size = UI_SIZE, classname = 'btn-rounded';
    
            return (
                <>
                    <Button 
                        variant="primary"
                        size={size} 
                        className={`d-flex align-items-center ${classname} ${inlineClass}`}
                        disabled={disabled}
                        onClick={(e) => callback(e)}
                        style={{ width: '100%' }}
                    >
                        <div className="d-flex align-items-center w-100">
                            <i className="fa-classic fa-light fa-circle-chevron-down fa-fw me-2" />
                            <span className="d-flex align-items-center" style={{fontSize: '0.825rem'}}>
                            {text}
                            {(count ?? 0) > 0 && (
                                <Badge 
                                    bg="dark" 
                                    text="white" 
                                    pill 
                                    className="ms-2 d-flex align-items-center justify-content-center"
                                >
                                {util.formatNumber(count, true)}
                                </Badge>
                            )}
                            </span>
                        </div>
                    </Button>

                </>

    
            )
        }
}

export default CommonButtonBadge;